import React, { useEffect, useState } from 'react'
import {
    useReactTable,
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    flexRender,
} from '@tanstack/react-table'
import DebouncedInput from "Components/Forms/DebouncedInput";

import Pagination from "./pagination";
import { Loader } from 'react-loaders';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import axiosInstance from 'Api';
import useSWR from 'swr';
import { CardFooter } from 'reactstrap';
const communitiesFetcher = async () => {
    const response = await axiosInstance.get("/get-communities");
    return response.data.communities || [];
};

const filterTableGeneric = (row, columnId, values, addMeta) => {

    let searchValues = values.split(/(\s+)/).filter(e => e.trim().length > 0);

    return searchValues.every((value) => {
        return Object.values(row.original).join(" ").toLowerCase().includes(value.toLowerCase());
    });
}

const ReactTableGenericForUsers = ({
    user,
    setUser,
    data,
    columns,
    filters,
    tableClassName,
    rowCount = 20,
    filterRecords,
    userTablePageSize,
    listSortingByKey,
    filterList,
    totalPageCount,
    paginate,
    pageNumber,
    setPageNumber,
    pageSizeCount,
    showLoader,
    selectedCommunityId,
    backendSorting = false,
    updateSortingHandler,
    setSelectedCommunityId,
    backendSortingState,
    count
}) => {

    const [globalFilter, setGlobalFilter] = React.useState('')
    const [sorting, setSorting] = React.useState([]);
    const userRoles = useSelector((state) => state.UserPermission);
    const [pageSize, setPageSize] = React.useState(pageSizeCount);
    const tableClass = tableClassName || "mb-0 table table-bordered table-sm table-striped table-hover";
    const { search = true, columnFilter = false, pagination = true, columnSorting = true } = filters || {};
    const fuzzyFilter = filterRecords ?? filterTableGeneric;
    const location = useLocation();

    const reactTablePageSize = (value) => {
        userTablePageSize(value);
    }

    const updatePaginate = (val) => {
        paginate(val);
    }

    const table = useReactTable({
        data,
        columns,
        state: {
            sorting,
            globalFilter,
        },
        onSortingChange: backendSorting
            ? (updater) => {
                const sortObj = typeof updater === 'function' ? updater(sorting) : updater;
                if (sortObj.length > 0) {
                    const { id } = sortObj[0];
                    let order = '';
                    let sortKey = id;
                    if (backendSortingState.key === id) {
                        switch (backendSortingState.order) {
                            case 'asc':
                                order = '';
                                sortKey = 'fullname';
                                break;
                            case 'desc':
                                order = 'asc';
                                break;
                            default:
                                order = 'desc';
                                break;
                        }
                        updateSortingHandler(sortKey, order);
                    } else {
                        updateSortingHandler(id, 'desc');
                    }
                }
            }
            : setSorting,
        onGlobalFilterChange: setGlobalFilter,
        globalFilterFn: fuzzyFilter,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getSortedRowModel: backendSorting ? undefined : getSortedRowModel(),
    })

    useEffect(() => {
        table.setPageSize(pageSize)
    }, [pageSize]);


    const isAdmin = userRoles.roles?.includes("administrator");

    const isBeheerderPage =
        location.pathname === "/beheerder" ||
        location.pathname === "/beheerder/gebruikers";

    const shouldFetchCommunities =
        isAdmin && isBeheerderPage;

    const { data: communities = [] } = useSWR(
        shouldFetchCommunities
            ? "communities-list"
            : null,
        communitiesFetcher
    );

    const showCommunityFilter =
        location.pathname === '/beheerder' ||
        location.pathname === '/beheerder/gebruikers';

    const showRoleFilter =
        location.pathname === '/beheerder/gebruikers' ||
        location.pathname === '/beheerder' ||
        location.pathname === '/support/gebruikers';

    return (
        <div>
         
                {/* <div className="d-flex flex-wrap gap-3 align-items-center">
                    {showCommunityFilter && (
                        <div className="footer-field-min-width">
                            <select
                                className="form-select"
                                value={selectedCommunityId}
                                onChange={(e) => setSelectedCommunityId(e.target.value)}
                                aria-label="Filter besturen"
                            >
                                <option value="">Alle besturen</option>
                                {communities.map((comm) => (
                                    <option key={comm.iCommunityId} value={comm.iCommunityId}>
                                        {comm.vCommunityName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {showRoleFilter && (
                        <div className="footer-field-min-width">
                            <select
                                className="form-select"
                                value={user}
                                onChange={(e) => setUser(e.target.value)}
                                aria-label="Filter rol"
                            >
                                <option value="">Filteren</option>
                                <option value="Favorieten">Favorieten</option>
                                {userRoles.roles?.includes('administrator') && (
                                    <option value="administrators">Administrators</option>
                                )}
                                <option value="coordinator">Coordinator</option>
                                <option value="melder">Melder</option>
                                <option value="vervanger">Vervanger</option>
                            </select>
                        </div>
                    )}
                </div> */}

                {search ? (
                    <div className="form-group pull-right mb-0">
                        <DebouncedInput
                            value={globalFilter ?? ''}
                            onChange={(value) => filterList(String(value))}
                            className="form-control search mb-2"
                            placeholder="Zoeken..."
                        />
                    </div>
                ) : null}
          
            
            <div className='table-wrapper'>
                <table className={tableClass}>
                    <thead>
                        {table.getHeaderGroups().map(headerGroup => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map(header => {
                                    const canSort = header.column.getCanSort();
                                    const isSorted = backendSorting ? backendSortingState.order : header.column.getIsSorted(); // asc | desc | ''

                                    return (
                                        <th
                                            key={header.id}
                                            style={canSort ? { cursor: 'pointer' } : undefined}
                                            onClick={canSort ? header.column.getToggleSortingHandler() : undefined}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                {flexRender(
                                                    header.column.columnDef.header,
                                                    header.getContext()
                                                )}

                                                {backendSorting && header.id === backendSortingState.key && (
                                                    <>
                                                        {backendSortingState.order === 'asc' && <span>🔼</span>}
                                                        {backendSortingState.order === 'desc' && <span>🔽</span>}
                                                        {/* If order is '', no icon */}
                                                    </>
                                                )}

                                                {!backendSorting && (
                                                    <>
                                                        {isSorted === 'asc' && <span>🔼</span>}
                                                        {isSorted === 'desc' && <span>🔽</span>}
                                                    </>
                                                )}

                                            </div>
                                        </th>
                                    );
                                })}
                            </tr>
                        ))}
                    </thead>
                    {showLoader === false &&
                        <tbody>
                            {
                                table.getRowModel().rows.length ?
                                    table.getRowModel().rows.map(row => (
                                        <tr key={row.id}>
                                            {row.getVisibleCells().map(cell => (
                                                <td key={cell.id}>
                                                    {flexRender(
                                                        cell.column.columnDef.cell,
                                                        cell.getContext())
                                                    }
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                    : <tr><td colSpan={columns?.length} align='center'>Geen data beschikbaar</td></tr>
                            }
                        </tbody>
                    }
                </table>
            </div>

            {showLoader === true &&
                <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
            }
            {pagination ? <Pagination table={table} reactTablePageSize={reactTablePageSize} totalPageCount={totalPageCount} updatePaginate={updatePaginate} pageNumber={pageNumber} setPageNumber={setPageNumber} showLoader={showLoader} count={count} /> : null}
            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="chat-layout-footer__inner">
                    <div className="d-flex justify-content-between align-items-center">

                        <div className="d-flex gap-3">

                            {(location.pathname === "/beheerder" ||
                                location.pathname === "/beheerder/gebruikers") && (
                                    <div className="footer-field-min-width">
                                        <select
                                            className="form-select"
                                            value={selectedCommunityId}
                                            onChange={(e) =>
                                                setSelectedCommunityId(e.target.value)
                                            }
                                        >
                                            <option value="">Alle besturen</option>

                                            {communities.map((comm) => (
                                                <option
                                                    key={comm.iCommunityId}
                                                    value={comm.iCommunityId}
                                                >
                                                    {comm.vCommunityName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}

                            {(location.pathname === "/beheerder/gebruikers" ||
                                location.pathname === "/beheerder" ||
                                location.pathname === "/support/gebruikers") && (
                                    <div className="footer-field-min-width">
                                        <select
                                            className="form-select"
                                            value={user}
                                            onChange={(e) => setUser(e.target.value)}
                                        >
                                            <option value="">Alle</option>

                                             <option value="favorieten">
                                                Favorieten
                                            </option>

                                            {userRoles.roles?.includes("administrator") && (
                                                <option value="administrators">
                                                    Administrators
                                                </option>
                                            )}

                                            <option value="coordinator">
                                                Coordinator
                                            </option>
                                            <option value="melder">
                                                Melder
                                            </option>
                                            <option value="vervanger">
                                                Vervanger
                                            </option>
                                            <option value="geen_rol">
                                                Geen rol
                                            </option>
                                            
                                        </select>
                                    </div>
                                )}

                        </div>

                    </div>
                </CardFooter>
            </div>
        </div>
    )
}

export default ReactTableGenericForUsers;
